export default __webpack_public_path__ + "media/zurb/img/home/university-oregon-5e7c388dae681e3accae31fbcc6a697e.jpg";